import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    max-height: 150px;
    overflow-y: scroll;
    background: #FFF;
    border-radius: 0 0 5px 5px;
    padding: 5px;
    
    border-bottom: 1.5px solid rgba(128,128,128, 0.3);
    border-left: 1.5px solid rgba(128,128,128, 0.3);
    border-right: 1.5px solid rgba(128,128,128, 0.3);

    &::-webkit-scrollbar{
            background-color: #D3D3D3;
            border-radius: 4px;
            width: 5px;
    }

    div{
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        cursor: pointer;
        transition: all 300ms;

        input{
            margin-right: 5px;
        }

        &:hover{
            background: #D3D3D3;
        }
    }

    .button-container{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        button{
            width: 25%;
            border: 0;
            background-color: #7A05A7;
            color: #fff;
            padding: 5px;
            border-radius: 5px;
        }
    }
`;
